module.exports = __webpack_public_path__ + "static/egg-e8e67fbac6ff4dc6cefd87fde3db4266.png";